/* Nanit AU · interactions. One file, no dependencies. Everything degrades to a static page. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = w.matchMedia && w.matchMedia('(hover: none)').matches;
  var raf = w.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  /* 1. Reveal on scroll: elements start visible if there is no IO or motion is reduced. */
  var rv = [].slice.call(d.querySelectorAll('[data-rv]'));
  if (!reduce && 'IntersectionObserver' in w && rv.length) {
    d.documentElement.classList.add('nau-js');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('is-in'); }); }

  /* 2. Count-up figures: <span data-count="1080" data-decimals="0" data-prefix="" data-suffix="p"> */
  var counters = [].slice.call(d.querySelectorAll('[data-count]'));
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-count')), dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '', dur = 1400, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur);
      var v = to * ease(p); el.textContent = pre + v.toLocaleString('en-AU', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
      if (p < 1) raf(step);
    }
    raf(step);
  }
  if (counters.length) {
    if (reduce || !('IntersectionObserver' in w)) {
      counters.forEach(function (el) { var dec = parseInt(el.getAttribute('data-decimals') || '0', 10); el.textContent = (el.getAttribute('data-prefix') || '') + parseFloat(el.getAttribute('data-count')).toLocaleString('en-AU', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + (el.getAttribute('data-suffix') || ''); });
    } else {
      var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } }); }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    }
  }

  /* 3. Parallax: [data-plx="0.12"] moves at a fraction of scroll while on screen. */
  var plx = [].slice.call(d.querySelectorAll('[data-plx]'));
  if (plx.length && !reduce) {
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      raf(function () {
        var vh = w.innerHeight;
        plx.forEach(function (el) {
          var r = el.parentNode.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var f = parseFloat(el.getAttribute('data-plx')) || 0.12;
          var y = (r.top + r.height / 2 - vh / 2) * f * -1;
          el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.08)';
        });
        ticking = false;
      });
    }
    w.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* 3b. Stacked chapters: as the next section covers a pinned chapter, dim it and ease it back. */
  var stacks = [].slice.call(d.querySelectorAll('.nau-chapter'));
  if (stacks.length && !reduce) {
    var sticking = false;
    function onStack() {
      if (sticking) return; sticking = true;
      raf(function () {
        var vh = w.innerHeight;
        stacks.forEach(function (ch) {
          var wrap = ch.parentNode, next = wrap.nextElementSibling;
          while (next && !(next.classList && next.classList.contains('shopify-section'))) next = next.nextElementSibling;
          if (!next) return;
          var nt = next.getBoundingClientRect().top;
          var p = Math.min(1, Math.max(0, 1 - nt / vh));
          ch.style.setProperty('--cover', (p * 0.55).toFixed(3));
          ch.style.transform = p > 0 ? 'scale(' + (1 - p * 0.04).toFixed(4) + ')' : '';
        });
        sticking = false;
      });
    }
    w.addEventListener('scroll', onStack, { passive: true }); onStack();
  }

  /* 4. Tilt: [data-tilt] follows the pointer a few degrees. Skipped on touch and reduced motion. */
  if (!touch && !reduce) {
    [].slice.call(d.querySelectorAll('[data-tilt]')).forEach(function (el) {
      var box = el;
      box.addEventListener('pointermove', function (e) {
        var r = box.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        box.style.transform = 'perspective(1200px) rotateX(' + (-y * 6).toFixed(2) + 'deg) rotateY(' + (x * 8).toFixed(2) + 'deg)';
      });
      box.addEventListener('pointerleave', function () { box.style.transform = ''; });
    });
  }

  /* 5. Model bar: sticky bar shows once the hero has scrolled past, and tracks the section in view. */
  var bar = d.querySelector('[data-modelbar]');
  if (bar) {
    var hero = d.querySelector('.nau-hero');
    var links = [].slice.call(bar.querySelectorAll('a[href^="#"]'));
    function showBar() { var y = hero ? hero.getBoundingClientRect().bottom : 0; bar.classList.toggle('is-visible', y < 0); }
    w.addEventListener('scroll', function () { raf(showBar); }, { passive: true }); showBar();
    if ('IntersectionObserver' in w && links.length) {
      var targets = links.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
      var sio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id); }); } });
      }, { rootMargin: '-40% 0px -55% 0px' });
      targets.forEach(function (t) { sio.observe(t); });
    }
  }

  /* 6. Quote rotator: [data-quotes] shows one child at a time. */
  [].slice.call(d.querySelectorAll('[data-quotes]')).forEach(function (q) {
    var items = [].slice.call(q.children); if (items.length < 2) { if (items[0]) items[0].classList.add('is-on'); return; }
    var i = 0; items[0].classList.add('is-on'); if (reduce) return;
    var timer = setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 6000);
    q.addEventListener('pointerenter', function () { clearInterval(timer); });
  });

  /* 7. Hero video: make sure autoplay actually happens on iOS. */
  [].slice.call(d.querySelectorAll('.nau-hero video')).forEach(function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });

  /* 8. Award badge: overlaid onto the gallery via JS rather than editing the base-theme
     product section, so this stays a small, isolated addition. window.nauAwardBadgeSrc is
     set inline in theme.liquid, gated to the one product this badge belongs on. */
  if (w.nauAwardBadgeSrc) {
    var gallery = d.querySelector('.product__gallery-container');
    if (gallery) {
      var badge = d.createElement('img');
      badge.className = 'nau-award-badge';
      badge.src = w.nauAwardBadgeSrc;
      badge.alt = '2026 Bounty Baby Awards, Best Baby Monitor, Bronze Medal';
      badge.width = 140; badge.height = 186; badge.loading = 'lazy';
      gallery.appendChild(badge);
    }
  }
})();

/* header: hide on scroll down, reveal on scroll up; transparent until scrolled; mega panels with hover intent + keyboard */
(function () {
  var h = document.querySelector('[data-header]'); if (!h) return;
  var doc = document.documentElement, clear = h.hasAttribute('data-clear');
  var setH = function () { doc.style.setProperty('--nau-header-h', h.classList.contains('is-hidden') ? '0px' : h.offsetHeight + 'px'); doc.style.setProperty('--header-height', h.offsetHeight + 'px'); };
  var sec = h.closest('.shopify-section'), ann = sec && sec.previousElementSibling, annH = 0;
  var measureAnn = function () { annH = (ann && ann.offsetHeight) || 0; doc.style.setProperty('--nau-ann-h', annH + 'px'); };
  measureAnn();
  var lastY = window.scrollY, ticking = false;
  var onScroll = function () {
    var y = window.scrollY;
    h.classList.toggle('is-scrolled', y > Math.max(24, annH));
    h.classList.remove('is-hidden'); doc.classList.remove('nau-header-hidden');
    lastY = y; setH(); ticking = false;
  };
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', function(){ measureAnn(); setH(); }); setH(); onScroll();
  if (!clear) { doc.style.setProperty('--nau-header-static', '1'); doc.classList.add('nau-header-static'); }

  var items = [].slice.call(h.querySelectorAll('.has-panel')), openItem = null, t;
  function open(item) {
    if (openItem === item) return; close(true);
    openItem = item; var b = item.querySelector('[data-panel-btn]'), p = item.querySelector('[data-panel]');
    p.hidden = false; void p.offsetWidth; p.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true'); h.classList.add('is-open');
  }
  function close(fast) {
    if (!openItem) return; var b = openItem.querySelector('[data-panel-btn]'), p = openItem.querySelector('[data-panel]');
    p.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false');
    var el = p; setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, fast ? 0 : 350);
    openItem = null; h.classList.remove('is-open');
  }
  var hoverable = window.matchMedia('(hover:hover) and (min-width:1024px)').matches;
  items.forEach(function (item) {
    var b = item.querySelector('[data-panel-btn]');
    b.addEventListener('click', function (e) { e.preventDefault(); openItem === item ? close() : open(item); });
    if (hoverable) {
      item.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { open(item); }, 90); });
      item.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(close, 220); });
    }
  });
  h.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
  document.addEventListener('click', function (e) { if (openItem && !h.contains(e.target)) close(); });
  h.querySelector('[data-veil]').addEventListener('mouseenter', function () { close(); });
  document.addEventListener('focusin', function (e) { if (openItem && !h.contains(e.target)) close(); });
})();
